import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchAssignmentsApi(params, config) {
  return axiosRequest('post', serviceUrls.ASSIGNMENTS_GET_ASSIGNMENTS, params, config);
}

export function fetchAssignmentDetailHeaderApi(assignmentId) {
  return axiosRequest('get', serviceUrls.ASSIGNMENTS_FETCH_ASSIGNMENT_DETAIL_HEADER, { assignmentId });
}

export function updateAssignmentDetailsApi(params, config) {
  return axiosRequest('post', serviceUrls.ASSIGNMENTS_UPDATE_ASSIGNMENT_DETAILS, params, config);
}

export function fetchAssignmentDetailApi(assignmentId) {
  return axiosRequest('get', serviceUrls.ASSIGNMENTS_FETCH_ASSIGNMENT_DETAIL, { assignmentId });
}

export function fetchAssignmentServicesApi(params, config, recordId) {
  return axiosRequest('post', serviceUrls.ASSIGNMENTS_FETCH_ASSIGNMENT_SERVICES, { params, recordId }, config);
}

export function getAssignmentServicesApi(serviceInitServiceId) {
  return axiosRequest('get', serviceUrls.ASSIGNMENTS_GET_ASSIGNMENT_SERVICE, { serviceInitServiceId });
}

export function upsertAssignmentServicesApi(data) {
  return axiosRequest('post', serviceUrls.ASSIGNMENTS_UPSERT_ASSIGNMENT_SERVICE, data);
}

export function deleteAssignmentServicesApi(serviceInitServiceId) {
  return axiosRequest('post', serviceUrls.ASSIGNMENTS_DELETE_ASSIGNMENT_SERVICE + `/${serviceInitServiceId}`);
}
